__turbopack_context__.v({
  "className": "roboto_703701fd-module__CNcVtW__className",
  "variable": "roboto_703701fd-module__CNcVtW__variable",
});
